import { Component, inject } from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { NavigationStart, RouteConfigLoadEnd, RouteConfigLoadStart, Router } from '@angular/router';
import { LoadingService } from '../../services/loading.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  private readonly loadingService = inject(LoadingService);

  protected readonly config = toSignal(this.loadingService.loading$, { requireSync: true });

  constructor() {
    inject(Router).events
      .pipe(takeUntilDestroyed())
      .subscribe(event => {
        if (event instanceof NavigationStart)      this.loadingService.reset();
        if (event instanceof RouteConfigLoadStart) this.loadingService.show('small');
        if (event instanceof RouteConfigLoadEnd)   this.loadingService.hide();
      });
  }

  dismiss(): void {
    this.loadingService.hide(0);
  }
}
